export const message_text_styles = {
  formattedText: {
    fontFamily: '"Segoe UI", Roboto, Arial, sans-serif',
    fontSize: "var(--fs16)",
    lineHeight: 1.6,
    color: "var(--text)",
    maxWidth: 700,
    padding: "1rem 1.5rem",
    paddingRight: "2rem",
    background: "var(--conversation)",
    border: ".5px solid var(--border-color)",
    borderRadius: "25px 25px 0 25px",
    marginBottom: "8px",

    "& h1, & h2, & h3, & h4": {
      fontWeight: 600,
      marginTop: "0.3em",
      marginBottom: "0.3em",
      lineHeight: 1.3,
    },

    "& h1": {
      fontSize: "1.4rem",
      paddingBottom: "0.3em",
      color: "var(--markTitle)",
    },

    "& h2": {
      color: "var(--markTitle)",
      fontSize: "1.4rem",
      paddingBottom: "0.2em",
    },

    "& h3": {
      color: "var(--markTitle)",
      fontSize: "1.3rem",
      "&::after": {
        content: '""',
        display: "block",
        borderBottom: "2px solid var(--markLine)",
        marginTop: "8px",
      },
    },

    "& h4": {
      fontSize: "1.2rem",
      fontStyle: "italic",
      color: "var(--text)",
    },

    "& p": {
      margin: "0.6em 0",
    },

    "& ul": {
      paddingLeft: "1.5em",
      margin: "0.6em 0",
    },

    "& li": {
      margin: "0.4em 0",
      listStyle: "none",
    },

    "& strong": {
      fontWeight: 700,
      color: "var(--text)",
    },

    "& br": {
      lineHeight: 2,
      content: '""',
      display: "block",
      margin: "0.5em 0",
    },
  },
  conversation: {
    margin: "4px 16px",
    width: "268px",
    marginRight: "0px",
    color: "var(--text)",
    cursor: "pointer",
    padding: "8px",
    border: "1px solid transparent",
    "&:hover": {
      border: "1px solid var(--border-color)",
      backgroundColor: "var(--conversation)",
      borderRadius: "6px",
    },
  },
  rename: {
    margin: "4px 16px",
    width: "268px",
    marginRight: "0px",
    color: "var(--text)",
    cursor: "pointer",
    padding: "8px",
    border: "1px solid transparent",
  },
};
